/**
 * All the resume sections to display in the Resume component
 * @author Andrew Jarombek
 * @since 9/9/2018
 */

import JSXConverter from './JSXConverter';

const content2013 = [
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `My time at St. Lawrence University began in the fall of 2013.  When I 
                    first arrived, I wasn't sure what I wanted 
                    to study.  Luckily, St. Lawrence University is a liberal arts college that 
                    encourages students to explore different subject areas before picking a major.  
                    I decided to try CS101: Intro to Computer Science during my first semester.  At 
                    first I only enjoyed CS101 because there were no essays, and 
                    I really hated writing (which is funny considering I now write software 
                    development articles every week).  By the end of the semester I really enjoyed 
                    the challenge of writing code.  The class taught me basic imperative 
                    programming concepts in Python.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `After CS101 I decided to continue 
                    taking computer science classes.  I took one computer science class per 
                    semester for my first two years of college.  At the end of my Sophomore year 
                    I declared as a computer science major and started taking multiple programming 
                    classes each semester.  However, I still didn't research computer science 
                    or programming outside of class assignments.  That changed my Junior spring.`,
        children: null,
      },
    ],
  },
];

const content2016 = [
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `During my Junior spring I decided to take my computer science research 
                    more seriously.  I researched different software development concepts 
                    in my free time each day.  Eventually I began building my own software.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `I attribute a lot of my working habits to my time running Cross Country 
                    and Track & Field in college.  Being a three season athlete who ran 70+ miles 
                    a week taught me the value of hard work and dedication.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `The summer before my Senior year I began my software development career 
                    with an internship at Gartner in Stamford, Connecticut.  I worked on two 
                    different Java web applications that summer, one that used the Spring MVC 
                    framework.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `After my internship I was dedicated to working on software 
                    development projects.  I created a website for my Cross Country and 
                    Track & Field teams where the athletes could log their workouts.  I released 
                    the first version of `,
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://www.saintsxctf.com/',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'SaintsXCTF.com',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ' in December.  SaintsXCTF follows the ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/saints-xctf',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'LAMP stack',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ' and was the first website I built from scratch.',
        children: null,
      },
    ],
  },
];

const content2017 = [
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: 'In my final semester at St. Lawrence University I added more features to ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://www.saintsxctf.com/',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'SaintsXCTF.com',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ' and created an associated ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://goo.gl/RZocwU',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'Android app',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ' written in ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'hhttps://github.com/AJarombek/saints-xctf-android',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'Java',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: '.  In the fall I completed the SaintsXCTF ecosystem by building an ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://goo.gl/3rGmqJ',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'iOS app',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ' in ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/saints-xctf-ios',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'Swift.',
            children: null,
          },
        ],
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `After graduating I worked full time at Gartner.  I participated 
                    in a rotational program where I worked for a different team every six months, 
                    gaining exposure to different enterprise applications.  I also learned how 
                    different teams operate in a corporate setting.  My first rotation was 
                    full-stack development for an application using AngularJS, Java, Spring, and 
                    Oracle.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `During the last few months of the year I began preparation work for my 
                    personal website.  I learned advanced JavaScript features and began writing 
                    software development articles.`,
        children: null,
      },
    ],
  },
];

const content2018 = [
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `In 2018 I spent time with two different teams at Gartner.  On the first  
                     team I developed features for a Java application that passed messages with 
                     RabbitMQ. On the second team I created a Jenkins pipeline that automated 
                     database script deployments for the entire company.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `In my free time I continued my personal website preparation.  I learned 
                    Angular, React, Webpack, Sass, and how to build MEAN and MERN stack 
                    applications.  Along the way I wrote software development articles documenting 
                    my progress.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: 'In the summer I released my personal website ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/jarombek-com',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'jarombek.com',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ` which follows the MERN stack.  My personal website also uses AWS Lambda 
                    functions, AWS API Gateway, a Node.js command line application, and Terraform.`,
        children: null,
      },
    ],
  },
];

const content2019 = [
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `In 2019 I also worked for two different teams at Gartner.  On the first 
                    team I wrote Continuous Integration Jenkins jobs and transitioned the teams  
                    application model from a monolithic app to microservices.  I created a Jenkins 
                    job which deployed microservices to EKS (Amazon Elastic Kubernetes Service).  
                    I provided each microservice with Kubernetes configuration.  After graduating 
                    from Gartner's IT rotational program, I switched to my second team.  On the 
                    second team I developed new features for `,
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://www.gartner.com/reviews/home',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'PeerInsights',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: `, a public facing website that 
                    provides peer reviews on technology products.  It uses Oracle, Elasticsearch, 
                    Java (Spring), React.js, and Sass for its technology stack.`,
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: 'In my free time I improved the infrastructure of my first website ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://www.saintsxctf.com/',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'SaintsXCTF.com',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: '.  I moved it onto AWS and wrote the entire infrastructure as code with ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/saints-xctf-infrastructure',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'Terraform',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: '.  I also wrote Terraform IaC for my personal website ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/jarombek-com-infrastructure',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'jarombek.com',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ` and changed the website infrastructure from a virtual machine to 
                    containers.  I also focused on creating unit tests in Python for all my 
                    infrastructure.  Additionally my AWS Infrastructure has its own `,
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/global-aws-infrastructure',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'Jenkins server',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: ' for ',
        children: null,
      },
      {
        el: 'a',
        attributes: {
          href: 'https://github.com/AJarombek/global-jenkins-jobs',
        },
        value: null,
        children: [
          {
            el: '#text',
            attributes: null,
            value: 'automating tasks',
            children: null,
          },
        ],
      },
      {
        el: '#text',
        attributes: null,
        value: '.',
        children: null,
      },
    ],
  },
  {
    el: 'p',
    attributes: null,
    value: null,
    children: [
      {
        el: '#text',
        attributes: null,
        value: `Currently I'm developing more features for my personal website, working 
                    on version II of my SaintsXCTF website, and trying to write one software 
                    development article per week.  I'm continuing to build my personal brand and 
                    document all my knowledge and hard work.`,
        children: null,
      },
    ],
  },
];

const resumeSections = [
  {
    title: 'Beginning at St. Lawrence University',
    content: JSXConverter.createContentJSX(content2013),
    languages: ['Java', 'Python', 'SQL', 'C', 'Assembly'],
    technologies: ['PostgreSQL'],
    year: 2013,
  },
  {
    title: 'First Software Development Experiences',
    content: JSXConverter.createContentJSX(content2016),
    languages: ['Java', 'PHP', 'JavaScript', 'SQL', 'CSS', 'HTML'],
    technologies: ['Spring', 'Android', 'JQuery', 'MySQL'],
    year: 2016,
  },
  {
    title: 'Starting my Professional Career',
    content: JSXConverter.createContentJSX(content2017),
    languages: ['Java', 'Swift', 'JavaScript', 'PHP', 'CSS', 'HTML'],
    technologies: ['Android', 'iOS', 'AngularJS', 'Spring', 'JQuery', 'MongoDB', 'MySQL', 'Oracle'],
    year: 2017,
  },
  {
    title: 'Building a Software Ecosystem',
    content: JSXConverter.createContentJSX(content2018),
    languages: ['JavaScript', 'Java', 'TypeScript', 'Groovy', 'Sass', 'Haskell', 'HTML'],
    technologies: [
      'React',
      'Angular',
      'Webpack',
      'MongoDB',
      'RabbitMQ',
      'Oracle',
      'MySQL',
      'Jenkins',
      'Terraform',
      'AWS',
    ],
    year: 2018,
  },
  {
    title: 'Moving my Software Ecosystem onto the Cloud',
    content: JSXConverter.createContentJSX(content2019),
    languages: ['Python', 'JavaScript', 'Java', 'Sass', 'HCL', 'C#', 'HTML'],
    technologies: ['React', 'Jenkins', 'Terraform', 'CloudFormation'],
    year: 2019,
  },
];

export default resumeSections;
